import createAction from '../../common/services/create-action';

export const FETCH_BADGES_REQUEST = 'badges/FETCH_REQUEST';
export const FETCH_BADGES_SUCCESS = 'badges/FETCH_SUCCESS';
export const FETCH_BADGES_FAILURE = 'badges/FETCH_FAILURE';

export const fetchBadgesRequest = createAction(FETCH_BADGES_REQUEST);
export const fetchBadgesSuccess = createAction(FETCH_BADGES_SUCCESS, payload => payload);
export const fetchBadgesFailure = createAction(FETCH_BADGES_FAILURE);

const createApiBaseUrl = url => {
  if (url.includes('.wixsite.')) {
    const parts = url.split('/');
    parts.pop();
    return parts.join('/') + '/_api/';
  }
  return url + '/_api/';
};

export const fetchBadges = () => {
  return (dispatch, getState, { request, wixCodeApi }) => {
    dispatch(fetchBadgesRequest());
    const config = {
      headers: {
        Authorization: wixCodeApi.user.currentUser.instance,
        instance: null,
      },
    };
    config.baseUrl = createApiBaseUrl(wixCodeApi.location.baseUrl);
    const promise = request('/badge-definitions/v1/badge-definitions', config);

    return promise
      .then(res => dispatch(fetchBadgesSuccess(res.badges)), () => dispatch(fetchBadgesFailure()))
      .then(() => promise);
  };
};
